"use strict";

var _toConsumableArray = require("/opt/build/repo/node_modules/@babel/runtime/helpers/toConsumableArray.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = searchTree;

function searchTree(tree, value) {
  var key = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'key';
  var reverse = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

  var stack = _toConsumableArray(tree);

  while (stack.length) {
    var node = stack[reverse ? 'pop' : 'shift']();

    if (node[key] === value) {
      return node;
    }

    node.children && stack.push.apply(stack, _toConsumableArray(node.children));
  }

  return null;
}